import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./AgencyChildBilling.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import AgencyChildBillingRow from "./AgencyChildBillingRow/AgencyChildBillingRow";
import AgencyChildBillingStore from "./AgencyChildBillingStore";
import {useCommonContext} from "../../contexts/CommonContext";
import useOnEnterPress from '../../hooks/EnterPress';
import Typography from "@material-ui/core/Typography";


const AgencyChildBilling: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = new AgencyChildBillingStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        store.getElements();
        store.getAgencyBalance();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await store.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    const onSearch = () => {
        store.search()
    }
    useOnEnterPress(onSearch,[store]);

    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(value);
    }

    return (
        <Observer>
            {() => (
                <div className={classes.billing_periods_container}>
                    
                    {/* Card de Valor Total Devido */}
                    <div className={classes.total_due_card}>
                        <Typography className={classes.total_due_label}>
                            TOTAL
                        </Typography>
                        <Typography className={classes.total_due_value}>
                            {formatCurrency(store.totalDue)}
                        </Typography>
                    </div>

                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={store.filter}
                                     placeholder={i18n.translate("BILLING_PERIOD_FILTER_PLACEHOLDER")}
                                     onChange={(value) => {
                                         store.setFilter(value)
                                     }} onEnter={() => store.search()}/>
                        <Button
                            onClick={onSearch}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>

                    {!store.isEmpty &&
                    <div className={classes.billing_periods_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={i18n.translate("BILLING_PERIODS")}
                                        pagination={store.pagination}/>
                        
                        <div className={classes.elements_container}>
                            {store.billingPeriods.map((billingPeriod, i) => (
                                <AgencyChildBillingRow
                                    onUpdate={onUpdate}
                                    billingPeriod={billingPeriod}
                                    key={i}
                                />
                            ))}
                        </div>

                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={i18n.translate("BILLING_PERIODS")}
                            pagination={store.pagination}/>
                    </div>}

                    {store.isEmpty &&
                    <MessageCard icon={AccountBoxSharpIcon} title={i18n.translate("NO_BILLING_PERIODS_TITLE")}
                                 subtitle={i18n.translate("NO_BILLING_PERIODS_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default AgencyChildBilling;
